import MessageDialog from './MessageDialog';

export default MessageDialog;
export type { IMessageDialogProps } from './MessageDialog';
